module.exports = __webpack_public_path__ + "media/images/icon_list/badge-90b03d3d1b432cda78058c1906a6e79a.svg";